"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from "@cantera/design-system";
import { NeonAuthUIProvider } from "@neondatabase/auth-ui";
import Link from "next/link";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { authClient } from "@/lib/auth/client";
import { sendCodeToVerifyEmail } from "@/lib/auth/send-email-verification-code";
export function Providers(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = href => {
      sendCodeToVerifyEmail(href);
      router.push(href);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== router) {
    t2 = () => {
      router.refresh();
    };
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      otp: true
    };
    t4 = {
      providers: ["google"]
    };
    t5 = {
      fields: []
    };
    t6 = {
      SIGN_IN_WITH: "Continue with"
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== children || $[10] !== router.replace || $[11] !== t1 || $[12] !== t2) {
    t8 = <ThemeProvider><NeonAuthUIProvider authClient={authClient} navigate={t1} replace={router.replace} onSessionChange={t2} emailVerification={t3} social={t4} signUp={t5} localization={t6} redirectTo="/" Link={Link} organization={t7}>{children}</NeonAuthUIProvider></ThemeProvider>;
    $[9] = children;
    $[10] = router.replace;
    $[11] = t1;
    $[12] = t2;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}